
import { TSX, Component, Prop, Vue } from 'vue-facing-decorator';
import { Action, State } from 'vuex-facing-decorator';
import { LockDec } from '@/decorators';
interface Props {
  options: any
};

@Component({
})
export default class extends TSX<Props>()(Vue) implements Props {

  @Prop()
  options: any;

  @State("express", {
    namespace: "store"
  })
  expressList

  @Action("store/getExpress")
  getExpress

  loading = false
  submitLoading = false
  orderInfo: any = {
    orderGoods: []
  }
  sendList = [
    { name: "快递发货", value: 1 },
    { name: "无需物流", value: 2 },
  ]

  ruleForm = {
    /** 只放勾选中的行，每项是 { id: orderGoods.id, num: 本次发几件 } */
    goodsList: [] as { id: number, num: number }[],
    type: 1,
    expressBill: "",
    expressId: null,
  }

  /**
   * 还能发几件 = 购买数量 - 已发货数量。
   * 不看 packId：一条商品可以分多个包裹发，packId 只记得住最后一个，
   * 判断发完没有以后端的 sendNumber 为准
   */
  remainNum(row) {
    return Math.max((row.num || 0) - (row.sendNumber || 0), 0);
  }

  statusText(row) {
    let sent = row.sendNumber || 0;
    if (sent <= 0) return "待发货";
    if (sent >= (row.num || 0)) return "已发货";
    return "部分发货";
  }

  getSendItem(id) {
    return this.ruleForm.goodsList.find((item) => item.id == id) || null;
  }

  setSendNum(id, num) {
    let item = this.getSendItem(id);
    if (item) item.num = num;
  }

  /** 顶部统计按「件」算，不再按行数，和部分发货对得上 */
  get goodsInfo() {
    let waitSend = 0;
    let send = 0;
    (this.orderInfo.orderGoods || []).forEach((row) => {
      send += row.sendNumber || 0;
      waitSend += this.remainNum(row);
    });
    return { waitSend, send };
  }

  /** 还有货没发完的行，全选只勾这些 */
  get waitSendGoods() {
    return (this.orderInfo.orderGoods || []).filter((row) => this.remainNum(row) > 0);
  }

  get checkAll() {
    if (!this.waitSendGoods.length) return false;
    return this.waitSendGoods.every((row) => !!this.getSendItem(row.id));
  }

  get checkIndeter() {
    if (this.checkAll) return false;
    return this.ruleForm.goodsList.length > 0;
  }

  async created() {
    this.getExpress();
    this.loading = true;
    await this.getData();
    this.loading = false;
  }

  async getData() {
    let { error, data } = await this.$post("/manager/order/view", {
      id: this.options.id,
    });
    if (error) return;
    this.orderInfo = data;
  }

  checkAllGoods(bool) {
    if (!bool) {
      this.ruleForm.goodsList = [];
      return;
    }
    this.waitSendGoods.forEach((row) => {
      if (!this.getSendItem(row.id)) {
        /** 勾选时默认把还能发的全发掉，要少发再改「本次发货」 */
        this.ruleForm.goodsList.push({ id: row.id, num: this.remainNum(row) });
      }
    });
  }

  changeGoods(row) {
    let index = this.ruleForm.goodsList.findIndex((item) => item.id == row.id);
    if (index >= 0) {
      this.ruleForm.goodsList.splice(index, 1);
      return;
    }
    let remain = this.remainNum(row);
    if (remain <= 0) return;
    this.ruleForm.goodsList.push({ id: row.id, num: remain });
  }

  @LockDec("submitLoading")
  async submitForm() {
    if (!this.ruleForm.goodsList.length) {
      return this.$error("请选择发货商品");
    }
    if (this.ruleForm.type == 1) {
      if (!this.ruleForm.expressId) return this.$error("请选择快递公司");
      if (!this.ruleForm.expressBill) return this.$error("请输入物流单号");
    }
    await this.$postNotify("/manager/order/send-gooods", {
      id: this.options.id,
      /** 后端收的是「发哪一行、发几件」，不是 id 数组 */
      goodsList: this.ruleForm.goodsList.map((item) => {
        return { id: item.id, num: Number(item.num) };
      }),
      type: this.ruleForm.type,
      expressId: this.ruleForm.expressId,
      expressBill: this.ruleForm.expressBill,
    });
    this.$emit('resolve');
  }
}
